import * as React from 'react';

import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { ApplicationState } from 'clients/app/src/rootReducer';
import { useSelector } from 'react-redux';

import InsertQuestion from '~teacher/components/InsertQuestion/InsertQuestion';
import QuizQuestion from '~teacher/components/QuizQuestion/QuizQuestion';

import {
  makeSelectIsControlsDisabled,
  selectOrderedQuestions,
} from '../../slices/quiz/quizSelectors';
import { QuizEditorIsUploadingImageContext } from './QuizEditorIsUploadingImage';

interface Props {
  isLocked?: boolean;
  questionIds: Array<string | number>;
  quizId: string | number;
  insertQuestion: (questionType: QuestionTypes, position: number) => void;
  openGenerateQuestionDialog: (position: number) => void;
  openImportByTextDialog: (position: number) => void;
}

function QuizEditorQuizQuestions({
  isLocked,
  questionIds,
  quizId,
  insertQuestion,
  openGenerateQuestionDialog,
  openImportByTextDialog,
}: Props) {
  const handleInsertQuestion = React.useCallback(
    ({
      questionType,
      position,
    }: {
      questionType: QuestionTypes;
      position: number;
    }) => {
      insertQuestion(questionType, position);
    },
    [insertQuestion]
  );
  const orderedQuestions: ReturnType<typeof selectOrderedQuestions> =
    useSelector((state: ApplicationState) =>
      selectOrderedQuestions(state, { questionIds })
    );

  const hasCustomGradingWeight = orderedQuestions.some(
    (question) => question.gradingWeight !== 1
  );

  const isControlsDisabled = useSelector(makeSelectIsControlsDisabled());
  const lastQuestionIndex = orderedQuestions.length - 1;
  return (
    <>
      {orderedQuestions.map(({ questionId, order }, index) => (
        <QuizEditorIsUploadingImageContext.Consumer key={questionId}>
          {({ isUploadingImages }) => (
            <React.Fragment>
              {!isLocked && !isControlsDisabled && !isUploadingImages && (
                <InsertQuestion
                  onInsertQuestion={handleInsertQuestion}
                  position={order}
                  openGenerateQuestionDialog={openGenerateQuestionDialog}
                  openImportByTextDialog={openImportByTextDialog}
                />
              )}
              <QuizQuestion
                isLocked={isLocked}
                hasCustomGradingWeight={hasCustomGradingWeight}
                disableMoveUp={index === 0}
                disableMoveDown={index === lastQuestionIndex}
                questionId={`${questionId}`}
                quizId={quizId as number}
                order={order}
              />
            </React.Fragment>
          )}
        </QuizEditorIsUploadingImageContext.Consumer>
      ))}
    </>
  );
}

export default QuizEditorQuizQuestions;
